'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Headphones, Music, Archive, Play, Download, Mic } from 'lucide-react'
import { ReactComponent as TelegramIcon } from '@/assets/img/telegram-logo.svg'
import { useMetrica } from 'next-yandex-metrica'

export default function RecordingsSection() {
  const { reachGoal } = useMetrica()
  return (
    <div className="bg-black/40 backdrop-blur-xl rounded-2xl px-4 md:px-8 p-8 border border-radio-blue/20 shadow-xl transition-all">
      <div className="text-center mb-10">
        <div className="inline-flex items-center justify-center mb-4 p-3 rounded-full bg-radio-blue/10 border border-radio-blue/20">
          <Play className="text-radio-blue drop-shadow-md w-6 h-6" />
        </div>
        <h3 className="text-3xl font-display text-radio-blue mb-3 tracking-tight">Записи эфиров</h3>
        <p className="text-gray-300 max-w-3xl mx-auto text-lg">
          Пропустили стрим?
          <br /> Не беда — все выпуски можно спокойно дослушать и досмотреть!
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Boosty Card */}
        <div className="relative bg-black/60 backdrop-blur-lg border border-orange-500/20 rounded-2xl overflow-hidden shadow-xl hover:shadow-orange-700/10 transition-all duration-300 flex flex-col h-full">
          <div className="h-2 bg-gradient-to-r from-orange-500 to-red-500" />
          <div className="flex flex-col items-center p-7 text-center flex-grow">
            <div
              className="relative mb-6 flex items-center justify-center"
              style={{ width: '80px', height: '80px' }}
            >
              <span className="absolute inset-0 rounded-full bg-gradient-to-br from-orange-500/60 via-orange-400/40 to-red-500/60 blur-md opacity-70 animate-pulse" />
              <span className="relative z-10 flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-orange-700/80 to-red-700/80 shadow-lg border-4 border-orange-500/30">
                <Image
                  src="/assets/img/boosty.png"
                  alt="Boosty лого"
                  width={40}
                  height={40}
                  className="drop-shadow-lg"
                />
              </span>
            </div>
            <h4 className="text-2xl font-bold text-white mb-2 tracking-tight">На Boosty</h4>
            <div className="text-gray-300 text-base mb-6 max-w-xs mx-auto leading-relaxed">
              <ul className="space-y-3 mt-4">
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-8 h-8 min-w-8 min-h-8 rounded-full bg-orange-600/20 mr-3">
                    <Archive className="w-4 h-4 text-orange-400" />
                  </span>
                  <span className="text-gray-300">Все выпуски в MP3</span>
                </li>
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-8 h-8 min-w-8 min-h-8 rounded-full bg-orange-600/20 mr-3">
                    <Headphones className="w-4 h-4 text-orange-400" />
                  </span>
                  <span className="text-gray-300">Версия без голоса ведущего</span>
                </li>
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-8 h-8 min-w-8 min-h-8 rounded-full bg-orange-600/20 mr-3">
                    <Music className="w-4 h-4 text-orange-400" />
                  </span>
                  <span className="text-gray-300 text-left leading-[1.2]">
                    Подкаст Liquor в высоком качестве
                  </span>
                </li>
              </ul>
            </div>
            <div className="w-full flex justify-center mb-6">
              <div className="w-16 h-0.5 bg-gradient-to-r from-orange-400 via-orange-500 to-red-500 rounded-full opacity-60" />
            </div>
            <div className="mt-auto w-full max-w-xs">
              <Link
                href="https://boosty.to/nuvertal"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => reachGoal('boosty-link-click')}
                className="inline-flex items-center justify-center px-6 py-2.5 bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-500 hover:to-red-500 text-white rounded-xl transition-all border border-orange-500/40 hover:border-orange-400/70 shadow-md hover:shadow-orange-500/20 focus:outline-none focus:ring-2 focus:ring-orange-400/60 text-lg font-medium w-full"
              >
                Перейти на Boosty
              </Link>
            </div>
          </div>
        </div>

        {/* Telegram Card */}
        <div className="relative bg-black/60 backdrop-blur-lg border border-blue-500/20 rounded-2xl overflow-hidden shadow-xl hover:shadow-blue-700/10 transition-all duration-300 flex flex-col h-full">
          <div className="h-2 bg-gradient-to-r from-blue-500 to-indigo-500" />
          <div className="flex flex-col items-center p-7 text-center flex-grow">
            <div
              className="relative mb-6 flex items-center justify-center"
              style={{ width: '80px', height: '80px' }}
            >
              <span className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-500/60 via-blue-400/40 to-indigo-500/60 blur-md opacity-70 animate-pulse" />
              <span className="relative z-10 flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-blue-700/80 to-indigo-700/80 shadow-lg border-4 border-blue-500/30">
                <TelegramIcon width={40} height={40} className="text-[#38b0e3] drop-shadow-lg" />
              </span>
            </div>
            <h4 className="text-2xl font-bold text-white mb-2 tracking-tight">В Telegram</h4>
            <div className="text-gray-300 text-base mb-6 max-w-xs mx-auto leading-relaxed">
              <ul className="space-y-3 mt-4">
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-8 h-8 min-w-8 min-h-8 rounded-full bg-blue-600/20 mr-3">
                    <Download className="w-4 h-4 text-blue-400" />
                  </span>
                  <span className="text-gray-300">Все выпуски в MP3</span>
                </li>
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-8 h-8 min-w-8 min-h-8 rounded-full bg-blue-600/20 mr-3">
                    <Headphones className="w-4 h-4 text-blue-400" />
                  </span>
                  <span className="text-gray-300 text-left leading-[1.2]">
                    Без голоса ведущего, только музыка
                  </span>
                </li>
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-8 h-8 min-w-8 min-h-8 rounded-full bg-blue-600/20 mr-3">
                    <TelegramIcon width={16} height={16} className="text-blue-400" />
                  </span>
                  <span className="text-gray-300 text-left leading-[1.2]">
                    Прямой доступ в Telegram
                  </span>
                </li>
              </ul>
            </div>
            <div className="w-full flex justify-center mb-6">
              <div className="w-16 h-0.5 bg-gradient-to-r from-blue-400 via-blue-500 to-indigo-500 rounded-full opacity-60" />
            </div>
            <div className="mt-auto w-full max-w-xs">
              <Link
                href="https://t.me/tribute/app?startapp=sgJb"
                target="_blank"
                onClick={() => reachGoal('telegram-without-voice-link-click')}
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-4 py-2.5 bg-gradient-to-b from-indigo-600/90 to-indigo-700 hover:from-indigo-500/90 hover:to-indigo-600 text-white rounded-lg transition-all border border-indigo-500/30 hover:border-indigo-400/50 shadow-sm hover:shadow-indigo-500/20 focus:outline-none focus:ring-2 focus:ring-indigo-400/60 text-base font-medium group"
              >
                <Music className="w-4 h-4 min-w-4 min-h-4 text-indigo-300 group-hover:text-indigo-200 transition-colors" />
                <span>Перейти в Telegram</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
